import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

// Import the logo image (assuming it's relative to components/Header.js)
// Path: components/Header.js is in src/components/, so images are in src/images/ or public/images/
// Using the public path is safest if the image is in public/images/logo1.png
const logo = '../images/vnm logo.png';

const Header = () => {
    // State to toggle the mobile menu visibility
    const [isOpen, setIsOpen] = useState(false);

    // Function to toggle the mobile menu state
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Helper function to close menu (used by external links)
    const handleNavClick = () => {
        setIsOpen(false);
        window.scrollTo(0, 0);
    }

    return (
        <header className="header">
            {/* Logo Link (Order 1 on Mobile) */}
            <Link to="/" className="logo" onClick={handleNavClick}>
                <img src={logo} alt="VNM Hitech Solutions" className="logo-img" />
            </Link>

            {/* Contact Us Button (Order 2 on Mobile - Visible on mobile header) */}
            <Link to="/contact" className="button contact-button" onClick={handleNavClick}>Contact Us</Link>

            {/* Hamburger Icon (Order 3 on Mobile) */}
            <div
                className={`hamburger ${isOpen ? 'open' : ''}`}
                onClick={toggleMenu}
            >
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>

            {/* Navigation Menu (Hidden on mobile header, shown on click) */}
            <nav className={`nav ${isOpen ? 'open' : ''}`}>
                <Link to="/" onClick={handleNavClick}>Home</Link>
                <Link to="/services" onClick={handleNavClick}>Services</Link>
                <Link to="/careers" onClick={handleNavClick}>Careers</Link>
                <Link to="/courses" onClick={handleNavClick}>Courses</Link>
                <Link to="/about" onClick={handleNavClick}>About</Link>
                <Link to="/contact" onClick={handleNavClick}>Contact</Link>
            </nav>
        </header>
    );
};

export default Header;
